'use strict';
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$$rxSubscriber = exports.rxSubscriber = undefined;

var _root = require('../util/root');

var _Symbol = _root.root.Symbol;
var rxSubscriber = exports.rxSubscriber = typeof _Symbol === 'function' && typeof _Symbol.for === 'function' ? _Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
var $$rxSubscriber = exports.$$rxSubscriber = rxSubscriber;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/symbol/rxSubscriber.js
// module id = 95
// module chunks = 177